import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

/** Email of the signed-in Supabase user, or null (still loading, or dev-token sign-in). */
export function useSignedInEmail(): string | null {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    if (!supabase) return;
    let cancelled = false;
    void supabase.auth.getUser().then(({ data }) => {
      if (!cancelled) setEmail(data.user?.email ?? null);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return email;
}
